import { Component, OnInit, Input } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/services/token.service';
declare var require: any;
import { AuthenticateService } from '../../shared/services/authenticate.service';

@Component({
  selector: 'app-viewforms',
  templateUrl: './viewforms.component.html',
  styleUrls: ['./viewforms.component.sass']
})
export class ViewformsComponent implements OnInit {
  @Input() selctedReg;
  public loading: boolean;
  regFormsArray: any = [];
  groupName: string;
  globalImgUrl: string;
  farmerObject: any = [];
  landObject: any = [];
  chcObject: any = [];
  bazarObject: any = [];
  storageObject: any = [];
  loanObject: any = [];
  dealerObject: any = [];
  distributorObject: any = [];
  bankerObject: any = [];
  insuranceregObject: any = [];
  insuranceObject: any = [];
  farmmachineObject: any = [];
  serviceproviderObject: any = [];

  constructor( private authService: AuthenticateService,private tokenService : TokenStorageService) { }

  ngOnInit() {
    this.getForms();
    console.log("selctedReg", this.selctedReg)
      this.globalImgUrl = this.authService.s3url();
      this.groupName = this.tokenService.getGroup();
  }

  ngOnChanges() {
    this.getForms();
  }

  getForms() {
    this.farmerObject = require('../../shared/definedJsons/farmer.json');
    this.landObject = require('../../shared/definedJsons/land.json');
    this.chcObject = require('../../shared/definedJsons/chc.json');
    this.storageObject = require('../../shared/definedJsons/service-provider.json');
    this.dealerObject = require('../../shared/definedJsons/dealer.json');
    this.distributorObject = require('../../shared/definedJsons/distributor.json');
    this.bazarObject = require('../../shared/definedJsons/bazar.json');
    this.loanObject = require('../../shared/definedJsons/loanReq.json');
    this.insuranceObject = require('../../shared/definedJsons/insuranceReq.json');
    this.bankerObject = require('../../shared/definedJsons/loan.json');
    this.insuranceregObject = require('../../shared/definedJsons/insurance.json');
    this.farmmachineObject = require('../../shared/definedJsons/farm-machine.json');
    this.serviceproviderObject = require('../../shared/definedJsons/service-provider.json');
    this.getAllRegisteredForms();
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  getAllRegisteredForms() {
    this.loading = true;
    this.regFormsArray = [];
    if (this.selctedReg == 'Farmer Bazar') {
      this.regFormsArray = this.bazarObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Farmer Registration') {
      this.regFormsArray = this.farmerObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Land Registration') {
      this.regFormsArray = this.landObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Banker Registration') {
      this.regFormsArray = this.bankerObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Insurance Registration') {
      this.regFormsArray = this.insuranceObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Dealer') {
      this.regFormsArray = this.dealerObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'distributor') {
      this.regFormsArray = this.distributorObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Custom hiring centre') {
      this.regFormsArray = this.chcObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Storage') {
      this.regFormsArray = this.storageObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Crop Loan Request') {
      this.regFormsArray = this.loanObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'Crop Insurance Request') {
      this.regFormsArray = this.insuranceObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'serviceprovider') {
      this.regFormsArray = this.serviceproviderObject[0];
      this.loading = false;
    } else if (this.selctedReg == 'farmmachine') {
      this.regFormsArray = this.farmmachineObject[0];
      this.loading = false;
    }
    console.log("this.regFormsArray", this.regFormsArray, this.bazarObject[0]);
  }

}
